import React, { useState, useEffect, useRef } from "react";
import {fileNameType} from "../../utils/helpers";
import Config from "../../Config.json";
import Modal from './../module.modal';
import Icons from '../module.icons';
import Versions from '../module.versions';
import { apiCall } from "./../narrativeUtils/fetch";
import classNames from "classnames";

function TemplateSettings(props) {

  const [active, setActive] = useState();
  const [templates, setTemplates] = useState();
  const [searchFilter, setSearchFilter] = useState('');


function fetchObjs() {
      const get_url = Config.baseURLcms + "template/";

      function responseTask(response) {
        const assetJSON = response.data;
        setTemplates(assetJSON.results);
        console.log('templates', assetJSON.results)
      }
      apiCall("get", get_url, {}, responseTask, null)
}


// function onTemplate(objId) {
      
//       let pageCount = props.narrative.cms_sections.length;
//       if (pageCount < props.user.org.validations.maxPages) {
        
//          props.setShowLoader(true);
//         const api_url = Config.baseURLcms + 'template-add-page/';
//         var dataJSON = {
//           'narrative_id': props.narrative.id,
//           'section_id': objId
//         }
//         function responseTask(response){

//           setTimeout(() => {
//             props.fetchJSON(response.data,null,null,null,null)
//           }, 200);
          
//           props.setUnSavedChanges(false);
//         }
//         apiCall('POST', api_url, dataJSON, responseTask, null,  props.setFormError,  props.setShowLoader)

//       } else {
//         let newError = {
//           "heading": "Note",
//           "text": "You current have <strong>" + pageCount + "</strong> pages, the maximum number of pages permitted in a narrative."
//         };
//          props.setFormError(newError);
//       }
    
//     }

useEffect(() => {
    fetchObjs();
}, [])

  useEffect(() => {
    // console.log('page setting props', props.activeSectionObj)
    if (props.activeSectionObj) {
      setActive(props.activeSectionObj['active'])
      // console.log('active', props.activeSectionObj['active'])
    }
  }, [props.activeSectionObj])


  function onGoToTemplates(){
    console.log('onGoToTemplates', props.narrative.template_id)
    if (props.narrative.template_id){
      window.location.href = "/narratives/" + props.narrative.template_id + '/pages?back=' + props.narrative.id + ',' + props.activeSectionObj.id
    }

  }
    
    return(
       <div className="rightNav settingsOn" id="manifestColumn">
        <div className={"mediaSettings showSettings on"}>
           <div className="iconHeading flex spaceBetween">
              <h3 className="flex gap10"><Icons.AddTemplate /> Templates</h3> 

              <span className="flex gap20">
                <Icons.Pencil className="icon ui" onClick={() => onGoToTemplates()} />
                <Icons.Close className="icon ui" onClick={() => props.setShowTemplates(false)} />
              </span>
            
            </div>
          <div className="settingsGroup">
            <div className="settingsRow" style={{marginBottom: 10}}>
              <input type="text" className="inputField" placeholder="Search templates..." value={searchFilter} onChange={(e) => setSearchFilter(e.target.value)} autoComplete="off" style={{width: '100%', boxSizing: 'border-box', marginBottom: 10}} />
              {searchFilter && <span className="ui canvasLabel" onMouseDown={(e) => { e.preventDefault(); setSearchFilter(''); }} style={{cursor: 'pointer', float: 'left', width: '100%', marginBottom: 10}}>Clear</span>}
            </div>
            {templates &&(
              <div className="settingsRow flex flexColumn gap20">
              {templates.filter(obj => !searchFilter || (obj.title && obj.title.toLowerCase().includes(searchFilter.toLowerCase()))).map((obj, i) => (
                 <span className={"flex flexColumn gap10 ui templateChoice"} onClick={() => props.setShowTemplateModal(obj)} key={'template_' + i}>
                    {obj.screenshot_for_pdf ?
                      <img src={Config.mediaURL + obj.screenshot_for_pdf} className="templateImg" alt="screenshot" /> :
                      <div className="templateImg" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--mid-grey2)', color: '#999', fontSize: 12, aspectRatio: '16/9'}}>{obj.title || 'Untitled'}</div>
                    }
                    <p>{obj.title}</p>
                </span>
              ))}
              </div>
              )}
         

          </div>




          
        </div>                         
      </div>
    )
}

export default TemplateSettings;